import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Détection automatique des élèves ayant 2 carnets dans la même discipline + fusion directe (cible = carnet le plus avancé).
export function DuplicateCarnetsBanner({ onMerged, discLabel }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");
  const load = useCallback(() => api.get("/progression/duplicates").then((r) => setData(r.data)).catch(() => setData(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!data || !data.count) return null;
  const merge = async (g, src) => {
    if (!window.confirm(`Verser le carnet « ${src.student_name} » (${src.tech_count} techniques, ${src.avg}%) DANS « ${g.target.student_name} » (${g.target.tech_count} techniques, ${g.target.avg}%) ?\nLe doublon est supprimé après la fusion. Irréversible.`)) return;
    setBusy(src.id);
    try { const { data: r } = await api.post(`/progression/profile/${g.target.id}/merge`, { source_id: src.id }); toast.success(`Fusion : ${r.moved} déplacée(s), ${r.merged} fusionnée(s)`); await load(); onMerged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Fusion impossible"); } finally { setBusy(""); }
  };
  return (
    <div className="mb-4 text-sm text-amber-200 bg-amber-500/10 border border-amber-500/30 rounded-lg px-3 py-2 space-y-1.5" data-testid="carnets-duplicates-banner">
      <p className="font-semibold">🔗 {data.count} élève(s) avec 2 carnets dans la même discipline (doublons probables)</p>
      {data.groups.map((g) => (
        <div key={g.target.id} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`dup-group-${g.target.id}`}>
          <span className="text-white">{g.target.student_name}</span><span className="text-amber-300/70">· {discLabel ? discLabel(g.discipline) : g.discipline}</span>
          <span className="text-white/50">garder : {g.target.tech_count} tech. · {g.target.avg}% {g.target.current_belt ? `· ${g.target.current_belt}` : ""}</span>
          {g.sources.map((s) => (
            <button key={s.id} onClick={() => merge(g, s)} disabled={busy === s.id} className="px-2 py-1 rounded bg-amber-600 hover:bg-amber-500 text-black font-semibold disabled:opacity-40" data-testid={`dup-merge-${s.id}`}>
              {busy === s.id ? "…" : `Fusionner le doublon (${s.tech_count} tech. · ${s.avg}%)`}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
